import { render } from "./IconStack.vue?vue&type=template&id=936a63e6&bindings={\"href\":\"props\",\"icon1\":\"props\",\"icon2\":\"props\"}"
import script from "./IconStack.vue?vue&type=script&lang=js"
export * from "./IconStack.vue?vue&type=script&lang=js"
script.render = render

export default script